<template>
    <section class="slice slice-tag-description">
        <div class="slice-content text-left">
            <div v-for="(item, i) in slice.items" :key="`slice-item-${i}`" class="joy-mb-6">
                <h2 class="joy-mb-3">{{ item.question }}</h2>
                <PrismicRichText :field="item.answer" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {TagDescriptionSlice} from '@prismicio-types';

    defineProps(getSliceComponentProps<TagDescriptionSlice>(['slice', 'index', 'slices', 'context']));
</script>
